import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {Local} from "../../../domain/Local";
import {TreeNode} from "primeng/api";

@Injectable()
export class LocalSQLService extends AbstractSQLService<Local>{
    nomeTabela = "local"
  agenciavel = true

    // converte(local: Local, newButton: boolean): TreeNode<any> {
    //     if(!local) return null
    //     const no = {label: local.nome,  key: local.id+'', data: local, children:[]}
    //     for (const l of local['locais']) {
    //         no.children.push(this.converte(l, newButton))
    //     }
    //     if(newButton) {
    //         no.children.push({data: {'new': true, id: local.id}})
    //     }
    //     return no
    // }

  override toObject(row: any): Local {
        if(row.biomas)
            row.biomas = JSON.parse(row.biomas)
        return super.toObject(row);
    }

    async getItemComFilhos(id: string){
        const sql = `
                WITH RECURSIVE
                  nos_locais(nome, id, paiId, biomas, tipo) AS (
                    select nome, id, paiId, biomas, tipo from local  where id=?
                    UNION
                    SELECT local.nome, local.id, local.paiId, local.biomas, local.tipo FROM local, nos_locais
                     WHERE local.paiId=nos_locais.id
                  )
                SELECT * FROM nos_locais ;
        `
        const locais = await this.db.query(sql,[id])
        return this.getNos(locais.values, false)
    }


    async getNos(lista: any, newButton: any){
        const nos = lista.map((obj: { id: string; nome: any; })=> {
            const filhos = newButton ? [{data: {'new': true, id: obj.id}}] : []
            return  {label: obj.nome, key: obj.id + '', data: obj, children: filhos}
        })

        const mapa = nos.reduce(function(map: { [x: string]: any; }, no: { key: string | number; }) {
            map[no.key] = no;
            return map;
        }, {})
        nos.forEach((l: { data: { paiId: string | number | undefined; }; key: string | number; })=> {
            if(l.data.paiId != undefined) {
                const pai = mapa[l.data.paiId]
                if(pai == undefined)
                    console.log('pai inexistente: ', l.data.paiId)
                else
                    mapa[l.data.paiId].children.splice(0,0,mapa[l.key])
            }
        })
        return nos.filter((n: { data: { paiId: undefined; }; })=> n.data.paiId == undefined)
    }

    // getHierarquico(lista){
    //     const mapa = lista.reduce(function(map, no) {
    //         map[no.id] = no;
    //         return map;
    //     }, {})
    //     lista.forEach(l=> {
    //         l.locais=[]
    //         if(l.paiId != undefined) {
    //             const pai = mapa[l.paiId]
    //             if(pai == undefined)
    //                 console.log('pai inexistente: ', l.paiId)
    //             else
    //                 mapa[l.paiId].locais.push(mapa[l.id])
    //         }
    //     })
    //     return lista.filter(n=> n.paiId == undefined).map(o=> this.converte(o, true))
    // }

    // async incluiFilhos(local: Local){
    //     const resp = await this.sql.executeSql("select * from local where paiId=?",[local.id])
    //     local['locais'] = resp.rows
    //     for (const l of local['locais']) {
    //         await this.incluiFilhos(l)
    //     }
    // }

}
